/* dcl-lake-offer.js  (rev 21)
 * 2026-10-21: the on-page "Your price" is switched off for Lake (inScope false in
 *   theme.liquid). The discount now shows only in the cart, so the perk, button,
 *   and confirm copy say the deal comes off in the cart, not on the page.
 * 2026-10-03: perk, button, and confirm copy now point to the on-page price
 *   (dcl-your-price.js).
 * Dialed Cycling Lab — Lake offer module.
 *
 * Presents an unnamed discount offer on Lake pages after genuine user
 * interaction. Nothing renders on page load for a first-time visitor. Neither
 * the code string nor the discount amount is ever written to the page.
 *
 * Eligibility: the Liquid loader sets window.DCL_LAKE_OFFER_ELIGIBLE to false
 * on any Lake product tagged no-discount (Sale, Open Box, clearance). On those
 * pages the offer never fires and the recall tab is suppressed. A shopper who
 * already holds the offer gets a short note explaining why it does not apply
 * here, so a code that silently does nothing never looks broken.
 *
 * Styling follows the DCL brand-page system used by sections/brand-footer-cta
 * and sections/brand-intro: #1a1a1a to #0f0f0f dark surface, white primary
 * button with an #e8e8e6 hover and a 1px lift, uppercase eyebrow at 0.14em
 * tracking, 800-weight heading at -0.02em, 4px control radius, 6px card radius.
 *
 * Icons are inline SVG rather than an icon font, so they render regardless of
 * what the theme has loaded.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Config — edit these, not the logic below.
  // ---------------------------------------------------------------------------
  var CFG = {
    code: 'DIALEDFIT26',        // must match the Shopify discount code exactly
    eyebrow: 'Your deal',
    headline: 'Nice choice!',
    body: 'Two things come with this pair.',
    perkDeal: 'Your special price on this pair, applied when you add it to your cart.',
    perkCard: 'An additional $20 Dialed gift card will be emailed once your order is placed!',
    termsHref: '/pages/shoe-gift-card-terms',
    termsLabel: 'Terms',
    cta: 'Unlock my deal',
    save: 'Save this for later',
    tabLabel: 'Your deal',
    tabAria: 'Your saved deal, reopen it',
    inlineLabel: 'Your deal is saved — view it',
    // Where the saved-offer row is placed on a product page. First match wins.
    // If none match (collection pages), it falls back to the fixed edge tab.
    anchors: ['#MainContent form[action*="/cart/add"]', '#MainContent .product-form'],
    confirm: 'Your deal is unlocked. Add this pair to your cart and you’ll see your special price there.',
    ineligible: 'This pair is already marked down, so your discount won’t stack on it. It still works on full-price Lake shoes.',
    ineligibleLink: 'See the rest of the Lake range',
    ineligibleHref: '/collections/lake-cycling',
    dwellMs: 3000,               // fire after this long on page
    scrollPct: 0.25,             // or after this much of the page is scrolled
    armDelayMs: 1500,            // minimum time on page before any trigger counts
    sessionKey: 'dcl_lake_offer_shown',
    appliedKey: 'dcl_lake_offer_applied',
    savedKey: 'dcl_lake_offer_saved',
    noteKey: 'dcl_lake_offer_note_seen'
  };

  var SVG_NS = 'http://www.w3.org/2000/svg';

  var ICONS = {
    tag: ['M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
          'M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z'],
    check: ['M5 12l5 5l10 -10'],
    bookmark: ['M18 7v14l-6 -4l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4z'],
    gift: ['M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z',
           'M12 8l0 13',
           'M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7',
           'M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5'],
    info: ['M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', 'M12 9h.01', 'M11 12h1v4h1'],
    x: ['M18 6l-12 12', 'M6 6l12 12']
  };

  function icon(name, size) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    ICONS[name].forEach(function (d) {
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
    });
    return svg;
  }

  // ---------------------------------------------------------------------------
  // Guards
  // ---------------------------------------------------------------------------
  if (window.__dclLakeOffer) return;
  window.__dclLakeOffer = true;

  // Never run for automated agents. MAP monitors and SEO crawlers set this.
  if (navigator.webdriver) return;

  var store = {
    get: function (k, s) {
      try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; }
    },
    set: function (k, v, s) {
      try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {}
    }
  };

  function track(event, extra) {
    if (!window.dataLayer) return;
    var payload = { event: event };
    if (extra) { for (var k in extra) { payload[k] = extra[k]; } }
    window.dataLayer.push(payload);
  }

  // Asks Shopify what is actually on the cart rather than trusting our own flag.
  // On any failure we report true, so a network hiccup makes the offer quieter
  // rather than nagging someone who already has it.
  function cartHasCode(cb) {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return cb(true);
          var codes = cart.discount_codes || [];
          var want = CFG.code.toUpperCase();
          for (var i = 0; i < codes.length; i++) {
            var c = codes[i] && codes[i].code;
            if (c && String(c).toUpperCase() === want) return cb(true);
          }
          cb(false);
        })
        .catch(function () { cb(true); });
    } catch (e) { cb(true); }
  }

  function holdsOffer() {
    return store.get(CFG.appliedKey, true) === 'done' || !!store.get(CFG.savedKey);
  }

  // ---------------------------------------------------------------------------
  // Ineligible page — clearance, open box, anything tagged no-discount.
  // The offer never fires here and the tab stays hidden. Someone who already
  // holds the offer gets one short explanation instead of silent failure.
  // ---------------------------------------------------------------------------
  if (window.DCL_LAKE_OFFER_ELIGIBLE === false) {
    if (holdsOffer() && !store.get(CFG.noteKey, true)) {
      store.set(CFG.noteKey, '1', true);
      injectStyles();
      onBody(showIneligibleNote);
    }
    return;
  }

  // Returning from /discount/ — confirm the apply, then stand down for good.
  if (store.get(CFG.appliedKey, true) === 'pending') {
    store.set(CFG.appliedKey, 'done', true);
    injectStyles();
    onBody(showConfirmBar);
    return;
  }

  // Applied earlier in this session. That is only the end of the story while the
  // code is actually still on the cart. Clearing the cart, removing the code
  // chip, or a cart expiring all drop it server side, and the shopper is then
  // stranded: no code, and nothing on the page offering it back. So ask the
  // cart before staying quiet.
  if (store.get(CFG.appliedKey, true) === 'done') {
    cartHasCode(function (stillOn) {
      if (stillOn) return;
      store.set(CFG.appliedKey, 'lapsed', true);
      store.set(CFG.savedKey, String(Date.now()));
      injectStyles();
      onBody(function () { showTab(false); });
      track('dcl_lake_offer_recovered');
    });
    return;
  }

  // Previously saved — no auto-fire, but surface the recall tab so the offer
  // stays one click away on this and every later visit.
  if (store.get(CFG.savedKey)) {
    injectStyles();
    onBody(function () { showTab(false); });
    return;
  }

  // Already shown this session and not yet acted on.
  if (store.get(CFG.sessionKey, true)) return;

  var armed = false;
  var fired = false;
  var human = false;
  var dwellDone = false; // 2026-09-25: see the dwell trigger below
  var startedAt = Date.now();

  // ---------------------------------------------------------------------------
  // Humanity check — a real pointer, touch, key, or scroll must happen first.
  // Headless renderers fire none of these.
  // ---------------------------------------------------------------------------
  ['pointermove', 'touchstart', 'keydown', 'wheel'].forEach(function (evt) {
    window.addEventListener(evt, function onFirst() {
      human = true;
      if (dwellDone && ready()) show('dwell-late');
      ['pointermove', 'touchstart', 'keydown', 'wheel'].forEach(function (e2) {
        window.removeEventListener(e2, onFirst);
      });
    }, { once: true, passive: true });
  });

  setTimeout(function () {
    armed = true;
    // Re-check depth the moment the floor lifts. The scroll listener only
    // evaluates inside a scroll event, so a shopper who passed the threshold
    // during the arming window and then stopped scrolling would otherwise get
    // no further event and wait out the full dwell timer.
    if (ready() && scrolledPast()) show('scroll-armed');
  }, CFG.armDelayMs);

  function ready() { return armed && human && !fired; }

  // Scroll depth, asked as a question rather than measured only inside a
  // scroll event. Both the scroll listener and the arm timer use it.
  function scrolledPast() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    return h > 0 && (window.scrollY / h) >= CFG.scrollPct;
  }

  // ---------------------------------------------------------------------------
  // Triggers
  // ---------------------------------------------------------------------------

  // 1. Fit Finder completion — the strongest intent signal on the page.
  // Honoured either way: dcl-fitfinder.js may dispatch this event, and if it
  // does not, the DOM watcher below covers it without editing that file.
  document.addEventListener('dcl:fitfinder:complete', function () {
    human = true;
    if (!fired && Date.now() - startedAt > 1200) show('fitfinder');
  });

  // 1b. Fit Finder, observed rather than instrumented.
  // The fit finder renders into #lff-result inside its own #lff-modal. Firing
  // while that modal is open would stack two dialogs, so we wait for a real
  // size result and then for their modal to close.
  var fitDone = false;

  function fitResultIsReal() {
    var res = document.getElementById('lff-result');
    if (!res || !res.classList.contains('show')) return false;
    var card = document.getElementById('lff-reccard');
    if (card && card.style.display === 'flex') return true;
    // A successful run always names a EU size; the error states never do.
    var rec = document.getElementById('lff-rec');
    return !!rec && /\bEU\b/.test(rec.textContent || '');
  }

  function watchFitModal() {
    var modal = document.getElementById('lff-modal');
    if (!modal || modal.__dclOfferWatched || !window.MutationObserver) return;
    modal.__dclOfferWatched = true;
    new MutationObserver(function () {
      if (!fitDone || !modal.hidden || fired) return;
      setTimeout(function () { if (!fired) show('fitfinder'); }, 450);
    }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#lff-go')) return;
    human = true;
    watchFitModal();
    // The fit finder writes its result synchronously; this only waits out the
    // smooth scroll it triggers afterwards.
    setTimeout(function () { if (fitResultIsReal()) fitDone = true; }, 300);
  }, true);

  // 2. Scroll depth
  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking || !ready()) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      if (scrolledPast()) show('scroll');
    });
  }, { passive: true });

  // 3. Dwell time. 2026-09-25: timing cut to 1.5s arm, 3s dwell, 25% scroll.
  // If the dwell mark passes before the first real interaction, the offer
  // shows on that interaction instead of waiting for a scroll.
  setTimeout(function () { dwellDone = true; if (ready()) show('dwell'); }, CFG.dwellMs);

  // 4. Exit intent, desktop only
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && ready()) show('exit');
    });
  }

  // ---------------------------------------------------------------------------
  // Modal
  // ---------------------------------------------------------------------------
  function show(trigger) {
    if (document.querySelector('.dcl-lo-overlay')) return;
    fired = true;
    store.set(CFG.sessionKey, '1', true);
    injectStyles();

    var overlay = document.createElement('div');
    overlay.className = 'dcl-lo-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'dcl-lo-title');

    var card = document.createElement('div');
    card.className = 'dcl-lo-card';

    var close = document.createElement('button');
    close.className = 'dcl-lo-x';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close and save for later');
    close.appendChild(icon('x', 18));

    var eyebrow = document.createElement('p');
    eyebrow.className = 'dcl-lo-eyebrow';
    eyebrow.appendChild(icon('tag', 19));
    var eyeText = document.createElement('span');
    eyeText.textContent = CFG.eyebrow;
    eyebrow.appendChild(eyeText);

    var h = document.createElement('h2');
    h.id = 'dcl-lo-title';
    h.className = 'dcl-lo-title';
    h.textContent = CFG.headline;

    var p = document.createElement('p');
    p.className = 'dcl-lo-body';
    p.textContent = CFG.body;

    // Two perks, stated plainly. The discount amount is deliberately never
    // named; the gift card value is, because a fixed gift is not a price claim.
    var perks = document.createElement('div');
    perks.className = 'dcl-lo-perks';
    [['tag', CFG.perkDeal, 'deal'], ['gift', CFG.perkCard, 'card']].forEach(function (row) {
      var li = document.createElement('div');
      li.className = 'dcl-lo-perk dcl-lo-perk--' + row[2];
      var mark = document.createElement('span');
      mark.className = 'dcl-lo-perkmark';
      mark.appendChild(icon(row[0], 17));
      var txt = document.createElement('span');
      txt.className = 'dcl-lo-perktext';
      txt.textContent = row[1];
      // Only the gift card row carries a terms link. The discount row has no
      // terms to state, and naming the discount anywhere is the MAP line.
      if (row[2] === 'card') {
        txt.appendChild(document.createTextNode(' '));
        var terms = document.createElement('a');
        terms.className = 'dcl-lo-terms';
        terms.href = CFG.termsHref;
        terms.textContent = CFG.termsLabel;
        txt.appendChild(terms);
      }
      li.appendChild(mark);
      li.appendChild(txt);
      perks.appendChild(li);
    });

    // The CTA hands off to Shopify's discount endpoint, which attaches the code
    // to the session and returns the shopper to the page they were on. Neither
    // the code nor the amount is rendered as text anywhere.
    var here = window.location.pathname + window.location.search;
    var cta = document.createElement('a');
    cta.className = 'dcl-lo-cta';
    cta.href = '/discount/' + encodeURIComponent(CFG.code) +
               '?redirect=' + encodeURIComponent(here);
    cta.rel = 'nofollow';
    cta.appendChild(icon('tag', 17));
    var ctaText = document.createElement('span');
    ctaText.textContent = CFG.cta;
    cta.appendChild(ctaText);

    var save = document.createElement('button');
    save.className = 'dcl-lo-save';
    save.type = 'button';
    save.appendChild(icon('bookmark', 15));
    var saveText = document.createElement('span');
    saveText.textContent = CFG.save;
    save.appendChild(saveText);

    card.appendChild(close);
    card.appendChild(eyebrow);
    card.appendChild(h);
    card.appendChild(p);
    card.appendChild(perks);
    card.appendChild(cta);
    card.appendChild(save);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    cta.focus();

    var settled = false;

    // Both the explicit save and the incidental close park the offer in the
    // tab. They differ only in whether the tab announces itself, and in what
    // gets tracked.
    function park(path) {
      if (settled) return;
      settled = true;
      store.set(CFG.savedKey, String(Date.now()));
      track('dcl_lake_offer_save', { path: path, trigger: trigger });
      overlay.classList.remove('is-open');
      setTimeout(function () {
        overlay.remove();
        showTab(path === 'save_button');
      }, 200);
    }

    save.addEventListener('click', function () { park('save_button'); });
    close.addEventListener('click', function () { park('close_x'); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) park('backdrop');
    });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape' && !settled && document.body.contains(overlay)) {
        park('escape');
        document.removeEventListener('keydown', onEsc);
      }
    });

    cta.addEventListener('click', function () {
      settled = true;
      store.set(CFG.appliedKey, 'pending', true);
      track('dcl_lake_offer_accept', { trigger: trigger });
    });

    track('dcl_lake_offer_view', { trigger: trigger });
  }

  // ---------------------------------------------------------------------------
  // Recall tab — persists until the offer is redeemed.
  // announce=true gives it a short attention pulse, used when the shopper
  // deliberately saved and should see where the offer went.
  // ---------------------------------------------------------------------------
  function findAnchor() {
    for (var i = 0; i < CFG.anchors.length; i++) {
      var el = document.querySelector(CFG.anchors[i]);
      if (el) return el;
    }
    return null;
  }

  function showTab(announce) {
    if (document.querySelector('.dcl-lo-tab') || document.querySelector('.dcl-lo-inline')) return;
    if (store.get(CFG.appliedKey, true) === 'done') return;
    // 'lapsed' deliberately falls through: they had the offer and lost it.
    injectStyles();

    var anchor = findAnchor();
    var inline = !!anchor;

    var tab = document.createElement('button');
    tab.className = inline ? 'dcl-lo-inline' : 'dcl-lo-tab';
    tab.type = 'button';
    tab.setAttribute('aria-label', CFG.tabAria);
    tab.appendChild(icon('tag', 16));
    var label = document.createElement('span');
    label.textContent = inline ? CFG.inlineLabel : CFG.tabLabel;
    tab.appendChild(label);

    tab.addEventListener('click', function () {
      tab.remove();
      fired = false;
      track('dcl_lake_offer_tab_click', { placement: inline ? 'inline' : 'edge' });
      show('recall-tab');
    });

    if (inline) anchor.parentNode.insertBefore(tab, anchor);
    else document.body.appendChild(tab);

    requestAnimationFrame(function () {
      tab.classList.add('is-open');
      if (announce) {
        tab.classList.add('is-new');
        setTimeout(function () { tab.classList.remove('is-new'); }, 2200);
      }
    });

    track('dcl_lake_offer_tab_shown', {
      announced: !!announce,
      placement: inline ? 'inline' : 'edge'
    });
  }

  // ---------------------------------------------------------------------------
  // Bottom bar — shared shell for the confirmation and the ineligible note.
  // ---------------------------------------------------------------------------
  function bottomBar(opts) {
    var bar = document.createElement('div');
    bar.className = 'dcl-lo-bar' + (opts.variant ? ' dcl-lo-bar--' + opts.variant : '');
    bar.setAttribute('role', 'status');

    var mark = document.createElement('span');
    mark.className = 'dcl-lo-barmark';
    mark.appendChild(icon(opts.icon, 15));

    var body = document.createElement('span');
    body.className = 'dcl-lo-bartext';
    var txt = document.createElement('span');
    txt.textContent = opts.text;
    body.appendChild(txt);

    if (opts.linkText && opts.linkHref) {
      var a = document.createElement('a');
      a.className = 'dcl-lo-barlink';
      a.href = opts.linkHref;
      a.textContent = opts.linkText;
      body.appendChild(a);
    }

    var x = document.createElement('button');
    x.className = 'dcl-lo-barx';
    x.type = 'button';
    x.setAttribute('aria-label', 'Dismiss');
    x.appendChild(icon('x', 16));
    x.addEventListener('click', function () { bar.remove(); });

    bar.appendChild(mark);
    bar.appendChild(body);
    bar.appendChild(x);
    document.body.appendChild(bar);
    requestAnimationFrame(function () { bar.classList.add('is-open'); });
    if (opts.autoHideMs) {
      setTimeout(function () { bar.classList.remove('is-open'); }, opts.autoHideMs);
      setTimeout(function () { if (bar.parentNode) bar.remove(); }, opts.autoHideMs + 400);
    }
    return bar;
  }

  // Shown on return from /discount/ so the shopper knows the click did
  // something. Without this the page looks identical and the offer reads
  // as broken.
  function showConfirmBar() {
    bottomBar({ icon: 'check', text: CFG.confirm, autoHideMs: 9000 });
  }

  // Shown on a clearance or open box page to a shopper who already holds the
  // offer, so a code that legitimately does not apply never looks like a bug.
  function showIneligibleNote() {
    bottomBar({
      icon: 'info',
      variant: 'info',
      text: CFG.ineligible,
      linkText: CFG.ineligibleLink,
      linkHref: CFG.ineligibleHref,
      autoHideMs: 12000
    });
    track('dcl_lake_offer_ineligible_note');
  }

  function onBody(fn) {
    if (document.body) fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---------------------------------------------------------------------------
  // Styles — injected at render time, not on load.
  // Values mirror sections/brand-footer-cta.liquid and sections/brand-intro.liquid.
  // ---------------------------------------------------------------------------
  function injectStyles() {
    // Styles now live in assets/dcl-lake-offer.css, loaded by theme.liquid on
    // the same condition as this script. Kept as a no-op so every existing
    // call site stays valid.
  }
})();
